// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IVehicleType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    nMVTISVehicleTypeCode: string;
    nMVTISVehicleTypeDisplayValue: string;
    isMotorized: boolean;
    sortOrder: number;
    active: boolean;
}

export class VehicleType implements IVehicleType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public nMVTISVehicleTypeCode: string;
    public nMVTISVehicleTypeDisplayValue: string;
    public isMotorized: boolean;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Passenger VehicleType
	**/
    get Passenger(): IVehicleType {
        return this.FromId(1);
    }
    /**
		Returns Truck VehicleType
	**/
    get Truck(): IVehicleType {
        return this.FromId(2);
    }
    /**
		Returns Bus VehicleType
	**/
    get Bus(): IVehicleType {
        return this.FromId(3);
    }
    /**
		Returns Van VehicleType
	**/
    get Van(): IVehicleType {
        return this.FromId(4);
    }
    /**
		Returns Motorcycle VehicleType
	**/
    get Motorcycle(): IVehicleType {
        return this.FromId(5);
    }
    /**
		Returns Moped VehicleType
	**/
    get Moped(): IVehicleType {
        return this.FromId(6);
    }
    /**
		Returns Motor Scooter VehicleType
	**/
    get MotorScooter(): IVehicleType {
        return this.FromId(7);
    }
    /**
		Returns Neighborhood Electric Vehicle VehicleType
	**/
    get NEV(): IVehicleType {
        return this.FromId(8);
    }
    /**
		Returns Golf Cart VehicleType
	**/
    get GolfCart(): IVehicleType {
        return this.FromId(9);
    }
    /**
		Returns All Terrain Cycle VehicleType
	**/
    get ATC(): IVehicleType {
        return this.FromId(10);
    }
    /**
		Returns All Terrain Vehicle VehicleType
	**/
    get ATV(): IVehicleType {
        return this.FromId(11);
    }
    /**
		Returns Trailer VehicleType
	**/
    get Trailer(): IVehicleType {
        return this.FromId(12);
    }
    /**
		Returns Tent Trailer VehicleType
	**/
    get TentTrailer(): IVehicleType {
        return this.FromId(13);
    }
    /**
		Returns Travel Trailer VehicleType
	**/
    get TravelTrailer(): IVehicleType {
        return this.FromId(14);
    }
    /**
		Returns Motor Home VehicleType
	**/
    get MotorHome(): IVehicleType {
        return this.FromId(15);
    }
    /**
		Returns Mobile Home VehicleType
	**/
    get MobileHome(): IVehicleType {
        return this.FromId(16);
    }
    /**
		Returns Mobile Home VehicleType
	**/
    get NOEV(): IVehicleType {
        return this.FromId(17);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Passenger', displayValue: 'Passenger', description: 'Passenger', nMVTISVehicleTypeCode: 'AU', nMVTISVehicleTypeDisplayValue: 'Automobile', isMotorized: true, sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'Truck', displayValue: 'Truck', description: 'Truck', nMVTISVehicleTypeCode: 'TU', nMVTISVehicleTypeDisplayValue: 'Truck', isMotorized: true, sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'Bus', displayValue: 'Bus', description: 'Bus', nMVTISVehicleTypeCode: 'BU', nMVTISVehicleTypeDisplayValue: 'Bus', isMotorized: true, sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'Van', displayValue: 'Van', description: 'Van', nMVTISVehicleTypeCode: 'AU', nMVTISVehicleTypeDisplayValue: 'Automobile', isMotorized: true, sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, value: 'Motorcycle', displayValue: 'Motorcycle', description: 'Motorcycle', nMVTISVehicleTypeCode: 'MC', nMVTISVehicleTypeDisplayValue: 'Motorcycle', isMotorized: true, sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'Moped', displayValue: 'Moped', description: 'Moped', nMVTISVehicleTypeCode: '', nMVTISVehicleTypeDisplayValue: '', isMotorized: true, sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, value: 'MotorScooter', displayValue: 'Motor Scooter', description: 'Motor Scooter', nMVTISVehicleTypeCode: '', nMVTISVehicleTypeDisplayValue: '', isMotorized: true, sortOrder: 999999, active: false });
        this._dictionary.add('8', { id: 8, value: 'NEV', displayValue: 'Neighborhood Electric Vehicle', description: 'Neighborhood Electric Vehicle', nMVTISVehicleTypeCode: '', nMVTISVehicleTypeDisplayValue: '', isMotorized: true, sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, value: 'GolfCart', displayValue: 'Golf Cart', description: 'Golf Cart', nMVTISVehicleTypeCode: '', nMVTISVehicleTypeDisplayValue: '', isMotorized: true, sortOrder: 999999, active: true });
        this._dictionary.add('10', { id: 10, value: 'ATC', displayValue: 'All Terrain Cycle', description: 'All Terrain Cycle', nMVTISVehicleTypeCode: '', nMVTISVehicleTypeDisplayValue: '', isMotorized: true, sortOrder: 999999, active: true });
        this._dictionary.add('11', { id: 11, value: 'ATV', displayValue: 'All Terrain Vehicle', description: 'All Terrain Vehicle', nMVTISVehicleTypeCode: '', nMVTISVehicleTypeDisplayValue: '', isMotorized: true, sortOrder: 999999, active: true });
        this._dictionary.add('12', { id: 12, value: 'Trailer', displayValue: 'Trailer', description: 'Trailer', nMVTISVehicleTypeCode: '', nMVTISVehicleTypeDisplayValue: '', isMotorized: false, sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, value: 'TentTrailer', displayValue: 'Tent Trailer', description: 'Tent Trailer', nMVTISVehicleTypeCode: '', nMVTISVehicleTypeDisplayValue: '', isMotorized: false, sortOrder: 999999, active: true });
        this._dictionary.add('14', { id: 14, value: 'TravelTrailer', displayValue: 'Travel Trailer', description: 'Travel Trailer', nMVTISVehicleTypeCode: '', nMVTISVehicleTypeDisplayValue: '', isMotorized: false, sortOrder: 999999, active: true });
        this._dictionary.add('15', { id: 15, value: 'MotorHome', displayValue: 'Motor Home', description: 'Motor Home', nMVTISVehicleTypeCode: 'CH', nMVTISVehicleTypeDisplayValue: 'Motor Coach / DPU Vehicle', isMotorized: true, sortOrder: 999999, active: true });
        this._dictionary.add('16', { id: 16, value: 'MobileHome', displayValue: 'Mobile Home', description: 'Mobile Home', nMVTISVehicleTypeCode: '', nMVTISVehicleTypeDisplayValue: '', isMotorized: false, sortOrder: 999999, active: true });
        this._dictionary.add('17', { id: 17, value: 'NOEV', displayValue: 'NOEV', description: 'Neighborhood Occupantless Electric Vehicle', nMVTISVehicleTypeCode: '', nMVTISVehicleTypeDisplayValue: '', isMotorized: false, sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IVehicleType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IVehicleType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IVehicleType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IVehicleType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IVehicleType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
